/**
 * Assets: uvt-evidence.js
 * -----------------------------------------------------------------------------
 * Evidence section behaviour for sections/uvt-evidence.liquid.
 * - Pagination dots for the mobile card rail (uvt.initDots).
 * - News button that opens the report modal (uvt.initModals).
 * Uses uvt-base.js, which must load first. Re-initialises when the section is
 * re-rendered in the theme editor.
 *
 */
(() => {
  /**
   * Sets up every evidence section inside a container.
   * @param {ParentNode} container - Document or re-rendered section.
   */
  function initAll(container) {
    if (!window.uvt) {
      return;
    }

    container.querySelectorAll('[data-uvt-evidence]').forEach((root) => {
      window.uvt.initDots(
        root.querySelector('[data-uvt-rail]'),
        Array.from(root.querySelectorAll('[data-uvt-dot]')),
      );

      window.uvt.initModals(root);
    });
  }

  initAll(document);

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
